import { useEffect } from 'react'
import useCurrentEmployer from './useCurrentEmployer'
// import useCurrentUser from './useCurrentUser'

import { useTranslation } from './useTranslation'

const useRedirectUserLang = () => {
  const [currentUser] = useCurrentEmployer()
  const { currentLanguageNumber, changeLanguage, fromNumberToCode } = useTranslation()

  useEffect(() => {
    if (currentUser && currentLanguageNumber !== currentUser.language) {
      changeLanguage(fromNumberToCode(currentUser.language))
    }
  }, [currentUser])
}
export default useRedirectUserLang
